import './App.css';
import HomePage from './Components/HomePage/HomePage';
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import { InstantSearch } from 'react-instantsearch';
import './i18n';
import './local';

const win: any = window;

function App() {
  const algoliaClient = algoliasearch(
    'A47E3BWDPH',
    'e5c93dfd73b094a9553e9a07349b774e'
  );

  return (
    <InstantSearch
      searchClient={algoliaClient}
      indexName={
        document.documentElement.lang === 'en'
          ? 'dev_community_en'
          : 'dev_community_ar'
      }
    >
      <HomePage lang={win['lang']} />
    </InstantSearch>
  );
}

export default App;
